import { SET_CAVNAS_PROPERTY } from "./actionTypes";

export function setCanvasProperty(data) {
    return {
        type: SET_CAVNAS_PROPERTY,
        data
    }
}